import React, { useState } from "react";
import { DefaultButton, Pivot, PivotItem, PrimaryButton, Spinner } from "@fluentui/react";
import { Form, Formik } from "formik";
import SelectCobrandsForm from "../HubSettings/Forms/SelectCobrandsForm";
import ShowCobrandList from "../HubSettings/ShowCobrandList";
import ClientConsoleReportsOnOffSettingsTable from "./ClientConsoleReportsOnOffSettingsTable";
import FeatureSummary from "../../../Util/FeatureSummary";

const newCoBrandSettingsObject = {
    client: "",
    cobrandTag: "",
    cobrand: "",
};

const ClientConsoleReportsPage = () => {
    const [selectedKey, setSelectedKey] = useState("0");
    const [cobrandList, setCobrandList] = useState([]);

    const handleLinkClick = (item) => {
        const itemKey = item.props.itemKey;

        // Kinda janky fix for improving pivot UX, they shouldn't be used for sequential pages
        // like this but keeping to existing styles for now
        if (itemKey === "1" && cobrandList.length === 0) return;

        setSelectedKey(itemKey);
    };
    const handlePrevClick = () => setSelectedKey("0");
    const handleNextClick = () => setSelectedKey("1");
    
    return (
        <Formik initialValues={newCoBrandSettingsObject} isInitialValid={false}>
            {({ values }) => {
                return (
                    <Form style={{ maxWidth: "1300px" }}>
                        <div style={{ width: "100%" }} className="mt-1">
                            <Pivot selectedKey={selectedKey} onLinkClick={handleLinkClick}>
                                <PivotItem headerText="Select Cobrand" itemKey={"0"}>
                                    <SelectCobrandsForm />
                                </PivotItem>
                                <PivotItem headerText="Update Settings" itemKey={"1"}>
                                    <ClientConsoleReportsOnOffSettingsTable cobrandList={cobrandList} />
                                </PivotItem>
                            </Pivot>
                            <hr />
                            <div style={{ display: "flex", justifyContent: "space-between" }} className="mt-1">
                                {selectedKey === "0" ? (
                                    <div />
                                ) : (
                                    <DefaultButton text="Prev" onClick={handlePrevClick} />
                                )}
                                {selectedKey === "1" ? (
                                    <div />
                                ) : (
                                    <PrimaryButton text="Next" onClick={handleNextClick} disabled={cobrandList.length === 0}/>
                                )}
                            </div>
                        </div>

                        <ShowCobrandList
                            clients={values.client}
                            tags={values.cobrandTag}
                            cobrands={values.cobrand}
                            setParentCobrandList={setCobrandList}
                            setTotalToUpdate={() => {}}
                        />
                        <FeatureSummary
                            label="About Client Console Reports"
                            summary="Configure report visibility settings for client consoles. Select cobrands first, then update the on/off settings for each report type in the selected cobrands."
                        />
                    </Form>
                );
            }}
        </Formik>
    );
};

export default ClientConsoleReportsPage;
